import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Injectable } from '@angular/core';
import { HttpService } from '@app/core/http/http.service';

import { ConfigGraphicsDto } from '@app/shared/models/ipm/dto/ConfigGraphicsDto';
import { FilterView } from '@app/shared/models/ipm/FilterView';
import { Chart } from '@app/shared/models/ipm/Chart';

import { Observable } from 'rxjs';

@Injectable()
export class GraphicService {

  private sApiGetChartsData = '/api/graphics/getCharts';
  private sApiGetConfigGraphicsParameters = '/api/graphics/configGraphics';

  constructor(private http: HttpService) { }

  public getChartsData(filterView: FilterView): Observable<Chart> {
    return this.http.post<Chart>(this.sApiGetChartsData, filterView);
  }

  public getConfigGraphicsParameters(): Observable<ConfigGraphicsDto> {
    return this.http.get<ConfigGraphicsDto>(this.sApiGetConfigGraphicsParameters);
  }

  public getDateRangeFormatted(fromDate: NgbDateStruct, toDate: NgbDateStruct): string {
    const dateFormatted = toDate && fromDate.year != 0 ?
                          fromDate.year + '-' + fromDate.month.toString().padStart(2, '0') + '-' + fromDate.day.toString().padStart(2, '0') + ' - ' +
                          toDate.year + '-' + toDate.month.toString().padStart(2, '0') + '-' + toDate.day.toString().padStart(2, '0')
                          : ''

    return dateFormatted;
  }
}
